import { makeAutoObservable } from 'mobx'
import * as apiClient from 'src/utils/apiClient/paymentMethods'

export default class PaymentMethodStore {
  // Constructor ------------

  constructor() {
    makeAutoObservable(this)
  }

  // Actions ---------------

  getAccountTransferEditParams = async (params: apiClient.GetAccountTransferEditParamsParams) => {
    return await apiClient.getAccountTransferEditParams(params)
  }

  getCreditCardEditURL = async (params: apiClient.GetCreditCardEditURLParams) => {
    const { url } = await apiClient.getCreditCardEditURL(params)
    return url
  }
}
